import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import enCommon from './locales/en/common.json'
import frCommon from './locales/fr/common.json'
import esCommon from './locales/es/common.json'

/** Detect initial language from URL prefix, falling back to localStorage. */
const SUPPORTED = new Set(['en', 'fr', 'es'])

function getInitialLang(): string {
  const segments = window.location.pathname.split('/').filter(Boolean)
  const first = segments[0]?.toLowerCase() || ''
  if (SUPPORTED.has(first)) return first
  return 'en'
}

const initialLang = getInitialLang()

i18n.use(initReactI18next).init({
  resources: {
    en: { common: enCommon },
    fr: { common: frCommon },
    es: { common: esCommon },
  },
  lng: initialLang,
  fallbackLng: 'en',
  defaultNS: 'common',
  ns: ['common'],
  interpolation: {
    escapeValue: false, // React already handles XSS
  },
})

// Persist language choice on change
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('i18n_lang', lng)
})

export default i18n
